import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { RequireEntitlements } from '@/components/Auth/RequireEntitlements';
import { RecentCharges } from '@/components/Settings/Billing/RecentCharges';
import { UsageDetails } from '@/components/Settings/Billing/UsageDetails';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/settings/billing')({
  component: SecuredBillingPage,
});

function SecuredBillingPage() {
  return (
    <RequireEntitlements admins={['isSuperAdmin']}>
      <BillingPage />
    </RequireEntitlements>
  );
}

function BillingPage() {
  const { organizationDisplayName } = useUser();

  useEffect(() => {
    document.title = `${organizationDisplayName || 'Driver'} - Billing`;
  }, [organizationDisplayName]);

  return (
    <SettingsPageLayout title="Billing & Usage" subTitle="Track your consumption and view your upcoming bill">
      <UsageDetails />
      <RecentCharges />
      {/* <NextBill /> */}
    </SettingsPageLayout>
  );
}
